/** How shapes respond to pointer events, per kind of mode. */
export const ShapeInteraction = {
	/** Selection modes: shapes hover and select. */
	enabled: { trackHover: true, allowSelection: true },
	/** Draw modes: shapes are pass-through. */
	disabled: { trackHover: false, allowSelection: false },
	/** View-only modes: shapes hover but never select. */
	hoverOnly: { trackHover: true, allowSelection: false },
} as const;
